var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"q-img-container main-color"},[_c('v-runtime-template',{attrs:{"template":_vm.question.q}}),_c('div',{staticClass:"image-panel",attrs:{"align":"center"}},[_c('img',{attrs:{"src":_vm.question.path,"alt":"Imagen"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }